import { Injectable } from '@angular/core';
import { CONFIG } from '../../environments/config';
import { HttpClientService } from './http-client.service';

@Injectable({
    providedIn: 'root'
})
export class WarehouseService {
    constructor(private httpClientService: HttpClientService) { }

    public getDepartments() {
        return this.httpClientService.get(`${CONFIG.WAREHOUSE.GETDEPARTMENTS}`);
    }
    public getTransactionTypes() {
        return this.httpClientService.get(`${CONFIG.WAREHOUSE.GETTRANSACTIONTYPES}`);
    }
    // public saveDepartmentDefaults(data: any) {
    //     return this.httpClientService.post(`${CONFIG.WAREHOUSE.CREATEDEPARTMENTDEFAULT}`, data);
    // }

    public saveDepartmentDefaults(data: any) {
        return this.httpClientService.post(
            `${CONFIG.WAREHOUSE.CREATEDEPARTMENTDEFAULT}`,
            data
        );
    }
    public getDepartmentDefaults(warehouseId: number) {
        return this.httpClientService.get(
            `${CONFIG.WAREHOUSE.GETDEPARTMENTDEAFULT}/${warehouseId}`
        );
    }


}